import {Statistic} from '@primer/react-brand'
import {renderWithoutParagraphs} from '../../../utils'
import type {TextItem} from '../../../types'
import {SupportGrid} from './SupportGrid'

export function SupportStats({items}: {items: TextItem[]}) {
  return items.map((item, index) => (
    <SupportGrid.Item key={item.sys.id} index={index} total={items.length}>
      <Statistic>
        {item.fields.heading && (
          <Statistic.Heading weight="normal" size="800" style={{color: 'var(--brand-color-text-emphasized)'}}>
            {renderWithoutParagraphs(item.fields.heading)}
          </Statistic.Heading>
        )}
        {item.fields.description && (
          <Statistic.Description>{renderWithoutParagraphs(item.fields.description)}</Statistic.Description>
        )}
      </Statistic>
    </SupportGrid.Item>
  ))
}
